export default "__VITE_ASSET__D2pmkC5Z__";